import { jsxs as r, jsx as l } from "react/jsx-runtime";
const L = ({ size: i = 100 }) => {
  const e = typeof i == "number";
  return /* @__PURE__ */ r(
    "svg",
    {
      width: e ? i : i.width,
      height: e ? i : i.height,
      viewBox: "0 0 100 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ r("g", { clipPath: "url(#clip0_26241_56585)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
              fill: "#F3F3FD"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M35.4843 24.9638C35.5392 24.8156 35.7489 24.8156 35.8037 24.9638L38.1016 31.1738C38.4466 32.106 39.1816 32.841 40.1138 33.1859L46.3237 35.4838C46.472 35.5387 46.472 35.7484 46.3237 35.8032L40.1138 38.1011C39.1816 38.4461 38.4466 39.1811 38.1016 40.1133L35.8037 46.3233C35.7489 46.4715 35.5392 46.4715 35.4843 46.3233L33.1864 40.1133C32.8415 39.1811 32.1065 38.4461 31.1743 38.1011L24.9643 35.8032C24.8161 35.7484 24.8161 35.5387 24.9643 35.4838L31.1743 33.1859C32.1065 32.841 32.8415 32.106 33.1864 31.1738L35.4843 24.9638Z",
              fill: "var(--plac-icon-fill-active)",
              stroke: "var(--plac-primary-gray)",
              strokeWidth: "2"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M32.3165 44.3887L25.1608 51.5444C24.8282 51.8769 24.8283 52.416 25.1608 52.7485L49.9854 77.5732C50.3179 77.9057 50.857 77.9057 51.1895 77.5732L76.0142 52.7485C76.3467 52.416 76.3467 51.8769 76.0142 51.5444L63.0346 38.5648C62.8749 38.4051 62.6583 38.3154 62.4325 38.3154H46.1646L42.0866 39.8244C41.0378 40.2125 40.211 41.0394 39.8229 42.0881L38.0876 46.7778C37.2482 49.0462 34.0399 49.0462 33.2006 46.7778L32.3165 44.3887Z",
              fill: "var(--plac-icon-fill-active)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M38.7317 51.8551L47.3319 38.6836H62.968L76.2076 52.3304L51.3578 77.3157L38.7317 51.8551Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M31.934 43.3554L24.4532 50.8363C23.7301 51.5594 23.7301 52.7316 24.4532 53.4547L49.2778 78.2793C50.0008 79.0023 51.1731 79.0023 51.8961 78.2793L76.7208 53.4547C77.4438 52.7316 77.4438 51.5594 76.7208 50.8363L63.7412 37.8567C63.394 37.5095 62.9231 37.3145 62.432 37.3145H47.8845C47.6102 37.6446 47.2406 37.9161 46.7758 38.0881L43.4617 39.3145H62.3705L75.2015 52.1455L50.587 76.76L25.9724 52.1455L32.698 45.4199L31.934 43.3554Z",
              fill: "var(--plac-primary-gray)"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M38.3837 52.0277L47.6768 38.6747C47.836 38.4459 48.097 38.3096 48.3757 38.3096L52.8886 38.3095C53.1686 38.3095 53.4307 38.4472 53.5896 38.6777L62.7918 52.0272C62.9657 52.2794 62.9906 52.6056 62.8572 52.8813L51.3091 76.7402C50.9985 77.3819 50.084 77.3805 49.7753 76.7379L38.3151 52.8828C38.1822 52.6062 38.2084 52.2795 38.3837 52.0277Z",
              stroke: "var(--plac-primary-gray)",
              strokeWidth: "2"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M24.9592 52.3604H76.2147",
              stroke: "var(--plac-primary-gray)",
              strokeWidth: "2"
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_26241_56585", children: /* @__PURE__ */ l("rect", { width: "100", height: "100", fill: "white" }) }) })
      ]
    }
  );
};
export {
  L as UpsellIllustration
};
//# sourceMappingURL=index.es486.js.map
